import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdvisorWizard from './AdvisorWizard';
import { useSEO } from '../../hooks/useSEO';

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_precision-connect/artifacts/lvo1u53w_image.png";

export default function AdvisorRegistroPage() {
  useSEO({
    title: 'Acceso a la Red de Advisors | Conadvy',
    description: 'Solicite acceso a la red de advisors de Conadvy. Proceso de selección diseñado para los mejores profesionales.',
    path: '/advisor/registro',
  });
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="advisor-registro-page" className="min-h-screen bg-[#0C1730]">
      {/* Minimal header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0C1730]/95 backdrop-blur-sm border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
          <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} data-testid="wizard-header-logo">
            <img src={LOGO_DARK} alt="Conadvy" className="h-10 object-contain" />
          </a>
          <button
            onClick={() => navigate('/advisor')}
            data-testid="wizard-exit-btn"
            className="text-white/40 hover:text-white/80 text-sm tracking-wide transition-colors"
          >
            Guardar y salir
          </button>
        </div>
      </header>

      <section className="pt-24 pb-16 md:pt-28 md:pb-20">
        <AdvisorWizard />
      </section>
    </div>
  );
}
